import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PaginationService } from '../PaginationService';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-dms-search-document',
  templateUrl: './dms-search-document.component.html',
  styleUrls: ['./dms-search-document.component.scss']
})
export class DmsSearchDocumentComponent implements OnInit {

  selectedSearchValue: any = null;
  isProcessing: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  perPage3 = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pager3: any = {};
  pagedItems: any[]; pagedItems1: any[];
  pagedItems2: any[];
  pagedItems3: any[];
  dropDownForSearchValue: any = [{
    displayExp: "Document No.",
    valueExp: "documentNo"
  }, {
    displayExp: "Document Name",
    valueExp: "documentName"
  }]

  documentSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  @ViewChild('searchedDocumentPopup', { static: true }) searchedDocumentPopup: TemplateRef<any>;
  visibleSearchedDocumentPopup: MatDialogRef<TemplateRef<any>>;

  searchedDocumentPopupConfig = {
    width: '80%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService,) {
    this.selectedSearchValue = "documentNo";
  }

  ngOnInit(): void {
    this.breadCrumbList = ["Documents", "Repository"];
  }

  docIdOrName: any = "";
  searchedDocumentsList: any = [];
  searchDocuments() {
    this.searchedDocumentsList = [];
    let data: any = {};
    if (this.selectedSearchValue == "documentNo") {
      data['documentNo'] = this.docIdOrName;
      data['documentName'] = "undefined"
    } else {
      data['documentNo'] = "undefined";
      data['documentName'] = this.docIdOrName;
    }
    this.isProcessing = true;
    this.appService.searchDocumentsBasedOnCondition(data).subscribe((data: any) => {
      this.isProcessing = false;
      this.searchedDocumentsList = data;
      this.collectionSize = this.searchedDocumentsList.length;
      this.pager.totalPages = undefined;
      this.setPage1(1, 0);
      this.visibleSearchedDocumentPopup = this.dialog.open(this.searchedDocumentPopup, this.searchedDocumentPopupConfig);
    })

  }

  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.searchedDocumentsList.length, page, this.perPage, targetpage);
    this.pagedItems1 = this.searchedDocumentsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }

  searchValue1: any;
  cancelSearchedDocumentPopup() {
    this.visibleSearchedDocumentPopup.close();
  }

  breadCrumbList: any = [];
  breadCrumb = [];
  goToSubfolderPageFromSearchedDoc(doc: any) {
    this.visibleSearchedDocumentPopup.close();
    this.appService.setParentFolderId(doc.folderId);
    this.breadCrumb = doc.folderPath.split(">");
    for (const item of this.breadCrumb ?? []) {
      this.breadCrumbList.push(item);
    }
    this.appService.setDocumentBreadcrumbList(this.breadCrumbList);
    this.router.navigate(['/dashboard/subFolder', doc.folderName]);
  }

}
